import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Breadcrumb,
  Form,
  theme,
  Divider,
  Input,
  Select,
} from "antd";
import _ from "lodash";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useAuth from "../../../lib/hooks/useAuth";
import { routes } from "../../../routes";
import { EFFECTIVENESS, ERR_0022 } from "../../../lib/const";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import WithSidebar from "../../../templates/withSidebar";
import {
  getListDepartments,
  getListDivisions,
  getPerformanceById,
  updatePerformance,
  getProjectByYearlyPlan,
  getProjectByYearlyProject,
} from "../../../services/progressPerformance";
import { SUCCESS_CODE } from "../../../lib/const";

const { useToken } = theme;
const { Option } = Select;

export const EditPerformance = () => {
  const { token } = useToken();
  const { auth } = useAuth();
  const params = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [data, setData] = useState({});
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);
  const [dropdownProject, setDropdownProject] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [divisionId, setDivisionId] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [year, setYear] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const years = moment().add(1, "years").format("YYYY");
  const yearArray = [
    parseInt(years),
    parseInt(years - 1),
    parseInt(years - 2),
    parseInt(years - 3),
    parseInt(years - 4),
  ];
  const monthlyValueMaxLength = 500;

  const getPermission =
  auth?.user?.permissions &&
  _.get(
    auth?.user?.permissions.find(
      (item) => item.permissionName === "Application field"
    ),
    "permissionList",
    []
  ).find(
    (item) => item.pageName === "รายงานผลการดำเนินงานตามแผนปฏิบัติการ" && _.get(item,"customPermission['Access all years of budget']",false) === true
  );

  const createPermission =
  auth?.user?.permissions &&
  _.get(
    auth?.user?.permissions.find(
      (item) => item.permissionName === "Application field"
    ),
    "permissionList",
    []
  ).find(
    (item) => item.pageName === "รายงานผลการดำเนินงานตามแผนปฏิบัติการ" && _.get(item,"customPermission['Create/Update']",false) === true
  );

  const months = [
    {
      value: "10",
      name: "ตุลาคม",
    },
    {
      value: "11",
      name: "พฤศจิกายน",
    },
    {
      value: "12",
      name: "ธันวาคม",
    },
    {
      value: "1",
      name: "มกราคม",
    },
    {
      value: "2",
      name: "กุมภาพันธ์",
    },
    {
      value: "3",
      name: "มีนาคม",
    },
    {
      value: "4",
      name: "เมษายน",
    },
    {
      value: "5",
      name: "พฤษภาคม",
    },
    {
      value: "6",
      name: "มิถุนายน",
    },
    {
      value: "7",
      name: "กรกฎาคม",
    },
    {
      value: "8",
      name: "สิงหาคม",
    },
    {
      value: "9",
      name: "กันยายน",
    },
  ];

  const handleChange = (value) => {
    setDepartmentId(value);
    form.setFields([
      {
        name: "projectName",
        value: undefined,
      },
      {
        name: "divisionId",
        value: undefined,
      },
      {
        name: "projectId",
        value: undefined,
      },
    ]);
  };

  const onFinish = async (values) => {
    // const year = Number(values?.yearOfBudget) + 543;
    const request = {
      projectId: values.projectId,
      departmentId: values.departmentId,
      divisionId: values.divisionId,
      yearOfBudget: Number(values?.yearOfBudget),
      monthOfBudget: values.monthOfBudget,
      monthlyValue: values.monthlyValue,
      performanceValue: values.performanceValue,
      effectiveness: values.effectiveness,
      issues: values.issues,
      solutions: values.solutions,
      quarterlyForecast: values.quarterlyForecast,
      quarterlyIssue: values.quarterlyIssue,
      quarterlySolutions: values.quarterlySolutions,
      annualForecast: values.annualForecast,
      annualIssues: values.annualIssues,
      annualSolutions: values.annualSolutions,
      status: data.status,
    };

    const res = await updatePerformance(params.id, request);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.progress_tab_report);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setErrorMessage("รายงานผลดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
      } else {
        setErrorMessage("");
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchPerformanceById = useCallback(
    async (id) => {
      const res = await getPerformanceById(id);

      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setData(objectValue);
        setDepartmentId(objectValue?.departmentId);

        form.setFieldsValue({
          projectId: objectValue?.projectId,
          departmentId: objectValue?.departmentId,
          divisionId: objectValue?.divisionId,
          yearOfBudget: objectValue?.yearOfBudget,
          monthOfBudget: objectValue?.monthOfBudget,
          monthlyValue: objectValue?.monthlyValue,
          performanceValue: objectValue?.performanceValue,
          effectiveness: objectValue?.effectiveness,
          issues: objectValue?.issues,
          solutions: objectValue?.solutions,
          quarterlyForecast: objectValue?.quarterlyForecast,
          quarterlyIssue: objectValue?.quarterlyIssue,
          quarterlySolutions: objectValue?.quarterlySolutions,
          annualForecast: objectValue?.annualForecast,
          annualIssues: objectValue?.annualIssues,
          annualSolutions: objectValue?.annualSolutions,
          status: objectValue?.status,
        });
      }
    },
    [setData]
  );

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDivision(result_data);
      }
    } catch (error) {}
  }, [departmentId]);

  const fetchProjectByYearlyPlan = async () => {
    const request = {
      departmentId: form.getFieldValue().departmentId
        ? form.getFieldValue().departmentId
        : "",
      divisionId: form.getFieldValue().divisionId
        ? form.getFieldValue().divisionId
        : "",
      yearOfBudget: form.getFieldValue().yearOfBudget
        ? form.getFieldValue().yearOfBudget
        : "",
    };

    // const res = await getProjectByYearlyPlan(request);
    const res = await getProjectByYearlyProject(request);
    if (res.data.code === SUCCESS_CODE) {
      let result_data = res.data.objectValue;
      setDropdownProject(result_data);
    }
  };

  useEffect(() => {
    fetchProjectByYearlyPlan();
  }, [departmentId, divisionId, year]);

  useEffect(() => {
    fetchPerformanceById(params.id);
  }, [params.id, fetchPerformanceById]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.progress_tab_report);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลรายงานผล",
                },
                {
                  title: "รายละเอียด",
                },
                {
                  title: <span className="pr_green">แก้ไขข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              disabled={!createPermission}
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.progress_tab_report);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={"รายงานผล"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ปีงบประมาณ"
                    name={"yearOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    {getPermission ? (
                      <Select
                        allowClear
                        style={{
                          width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        onChange={() => {
                          let arr = form.getFieldValue().yearOfBudget;
                          setYear(arr);
                          form.setFields([
                            {
                              name: "projectId",
                              value: undefined,
                            },
                          ]);
                        }}
                      >
                        {yearArray.map((item) => (
                          <Option value={parseInt(item) + 543}>
                            {parseInt(item) + 543}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Input placeholder="ปีงบประมาณ" disabled />
                    )}
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="เดือนงบประมาณ"
                    name={"monthOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {months.map((m) => (
                        <Option value={m.value}>{m.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ฝ่าย"
                    name={"departmentId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={handleChange}
                    >
                      {dropDownDepartment.map((item) => (
                        <Option value={item.departmentId}>
                          {item.departmentNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="กอง"
                    name={"divisionId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={(value) => {
                        setDivisionId(value);
                        form.setFields([
                          {
                            name: "projectId",
                            value: undefined,
                          },
                        ]);
                      }}
                    >
                      {dropDownDivision.map((item) => (
                        <Option value={item.divisionId}>
                          {item.divisionNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="โครงการ"
                    name={"projectId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {dropdownProject.map((item) => (
                        <Option value={item.projectId}>
                          {item.projectNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                </Row>
                <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={"ประจำเดือน"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="ผลการดำเนินงานประจำเดือน (ท่านสามารถกรอกข้อความแบบยาวได้ไม่จำกัด)"
                    name={"monthlyValue"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <TextArea
                      placeholder="ผลการดำเนินงานประจำเดือน"
                      maxLength={monthlyValueMaxLength}
                      rows={3}
                    />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="% ความสำเร็จ(สะสม)"
                    name={"performanceValue"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="% ความสำเร็จ(สะสม)" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ประสิทธิผล"
                    name={"effectiveness"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {EFFECTIVENESS.map((item) => (
                        <Option value={item.value}>{item.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ปัญหาอุปสรรคในการดำเนินงาน"
                    name={"quarterlyIssue"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="ปัญหาอุปสรรคในการดำเนินงาน" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="แนวทางแก้ไขปัญหาอุปสรรคในการดำเนินงาน"
                    name={"quarterlySolutions"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="ปัญหาอุปสรรคในการดำเนินงาน" />
                  </Form.Item>
                </Col>
                </Row>
                <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={"ประจำไตรมาส"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="คาดการณ์ผลการดําเนินงาน ณ สิ้นไตรมาส"
                    name={"quarterlyForecast"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {EFFECTIVENESS.map((item) => (
                        <Option value={item.value}>{item.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="ปัญหาอุปสรรคในการดำเนินงาน"
                    name={"annualIssues"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="ปัญหาอุปสรรคในการดำเนินงาน" />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="แนวทางแก้ไขปัญหาอุปสรรคในการดำเนินงาน"
                    name={"annualSolutions"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="แนวทางแก้ไขปัญหาอุปสรรคในการดำเนินงาน" />
                  </Form.Item>
                </Col>
                </Row>
                
                <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={"ประจำปีงบประมาณ"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="คาดการณ์ผลการดําเนินงาน ณ สิ้นปีงบประมาณ"
                    name={"annualForecast"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {EFFECTIVENESS.map((item) => (
                        <Option value={item.value}>{item.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="ปัญหาอุปสรรคในการดำเนินงาน"
                    name={"issues"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ปัญหาอุปสรรคในการดำเนินงาน" />
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="แนวทางแก้ไขปัญหาอุปสรรคในการดำเนินงาน"
                    name={"solutions"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input.TextArea placeholder="แนวทางแก้ไขปัญหาอุปสรรคในการดำเนินงาน" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        title={errorMessage ? errorMessage : ""}
        subTitle={errorMessage ? "กรุณาทำการตรวจสอบข้อมูล" : ""}
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={setErrorMessage}
      />
    </WithSidebar>
  );
};
